export default __webpack_public_path__ + "static/media/020-cymbals.7cb24998.svg";